// extracted by mini-css-extract-plugin
export default {"container":"container--2mN-j9p"};